export default class RelanceAgenceModel {
  constructor(uuid) {
    this.uuid = uuid;
  }

  getUuid() {
    return this.uuid;
  }
}
